import React from 'react'
import { Box,Typography, BottomNavigation, BottomNavigationAction, TextField, Select, MenuItem }from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import { useRedirect } from 'react-admin'

function AddGroup() {
  const [value, setValue] = React.useState(0);
  const [groupName, setGroupname] = React.useState('')
  const [taxClass, setTaxclass] = React.useState('retail')

  const redirect = useRedirect()

  const redirectToList = () => {
    redirect('/customer-groups')
  }
  const handleSelect = (val) => {
    setTaxclass(val)
  }
  const handleReset = () => {
    setGroupname('')
    setTaxclass('retail')
  }
  const handleSubmit = () => {
    const payload = {
      group: groupName,
      class: taxClass
    }
    alert(`generated payload: ${payload.group, payload.class}`)
    redirectToList()
  }
  return (
    <Box sx={{ height: 'auto', margin: '10px 20px' }}>
      <Box sx={{ display: 'flex' }}>
        <Typography variant='h4'>
          New Customer Group
        </Typography>
      </Box>
      <Box>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{ '& .MuiBottomNavigationAction-root': {
            backgroundColor: globalStyles.colors.white,
            border: '2px solid #2b3f7a !important',
            color: '#2b3f7a',
            margin: '5px 10px !important',
            padding: '0 !important',
            fontSize: '0.9rem !important',
            '&:hover': {
              transform: 'scale(1.1, 1.1)'
            },
            '& .Mui-selected': {
              color: '#2b3f7a',
              transition: 'none',
              fontSize: '0.9rem'
            }
          } 
          }}
        >
        <BottomNavigationAction label="Back" onClick={redirectToList}/>
        <BottomNavigationAction label="Reset"  onClick={handleReset}/>
        <BottomNavigationAction label="Save Customer Group"  onClick={handleSubmit}
        sx={{ 
          backgroundColor: '#2b3f7a !important', 
          border: '2px solid #2b3f7a !important',
          color: '#fff !important'
        }}/>
      </BottomNavigation>
      </Box>
      <Box sx={{ margin: '20px 0px', 
      '& .MuiTypography-root': {
        fontSize: '1.5rem', 
        color: '#000 !important'
      }}}>
        <Typography variant='h6'>Group Information</Typography>
        <Box component='form' sx={{ margin: '5% 25%', display: 'block' }}>
        <Typography variant='caption' sx={{ fontSize: '0.9rem !important', lineHeight: '50px', paddingRight: '20px' }}>Group Name *</Typography>
          <TextField
            required
            id="outlined-required"
            //label="Group Name"
            sx={{ width: '450px' }}
            value={groupName}
            onChange={(e) => setGroupname(e.target.value)}
            helperText='Maximum length must be less than 32 characters'
          />
          <Box sx={{ display: 'flex', paddingTop: '30px' }}>
            <Typography variant='caption' sx={{ fontSize: '0.9rem !important', lineHeight: '50px', paddingRight: '20px' }}>Tax Class *</Typography>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={taxClass}
              label="Tax Class"
              sx={{ width: '470px' }}
              onChange={(e) => handleSelect(e.target.value)}
            >
              <MenuItem value={'retail'}>Retail Customer</MenuItem>
              <MenuItem value={'non-retail'}>Non Retail Customer</MenuItem>
              <MenuItem value={'regular'}>Regular Customer</MenuItem>
            </Select>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AddGroup